import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';

@Component({
	selector: 'app-dynamic-form-input-password',
	standalone: false,
	templateUrl: './dynamic-form-input-password.component.html',
	styleUrl: './dynamic-form-input-password.component.scss'
})
export class DynamicFormInputPasswordComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	toControlKey = AbstractDynamicForm.toControlKey;

}
